// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/So_ProductFiscalInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/product_fiscal/salvar
 *
 * Creates or updates the fiscal sidecar row for (so_product_fiscal_product_id,
 * so_product_fiscal_franchise_id). so_product_fiscal_franchise_id = null means
 * the global (franqueadora) row; an int overrides it for that franchise only.
 * All fiscal fields are optional — a row can exist "registered but empty",
 * distinct from no row at all (see So_product_fiscal_model).
 */
import { registerContract } from './validate'

export interface So_ProductFiscalInput {
so_product_fiscal_product_id: number
so_product_fiscal_franchise_id?: number
so_product_fiscal_ncm?: string
so_product_fiscal_cest?: string
so_product_fiscal_cfop_dentro_uf?: string
so_product_fiscal_cfop_fora_uf?: string
so_product_fiscal_cst?: string
so_product_fiscal_csosn?: string
so_product_fiscal_origem?: number
so_product_fiscal_unidade_tributavel?: string
}

registerContract('So_ProductFiscalInput', {
  so_product_fiscal_product_id:         { type: 'number',  required: true },
  so_product_fiscal_franchise_id:       { type: 'number',  required: false },
  so_product_fiscal_ncm:                { type: 'string',  required: false },
  so_product_fiscal_cest:               { type: 'string',  required: false },
  so_product_fiscal_cfop_dentro_uf:     { type: 'string',  required: false },
  so_product_fiscal_cfop_fora_uf:       { type: 'string',  required: false },
  so_product_fiscal_cst:                { type: 'string',  required: false },
  so_product_fiscal_csosn:              { type: 'string',  required: false },
  so_product_fiscal_origem:             { type: 'number',  required: false },
  so_product_fiscal_unidade_tributavel: { type: 'string',  required: false },
})
